export default __webpack_public_path__ + "static/media/danao.420aeeed.jpg";